import $ from 'jquery';

class Orphans {
    constructor(elem) {
        this.$body = $('body');
        this.$elem = $(elem);

        this.settings = {
            exceptions: [
                'dn.'
            ]
        };

        this.$elem.html(this.removeOrphans(this.$elem.html()));
    }

    checkWord(currentWord, words, i) {
        if (currentWord.length <= 2 || this.settings.exceptions.indexOf(currentWord.toLowerCase()) !== -1) {
            words[i + 1] = currentWord + '&nbsp;' + words[i + 1];
            words.splice(i, 1);
        }

        return words;
    }

    removeOrphans(data) {
        if (typeof data === 'string') {
            let words = data.replace(/\s+/g, ' ').trim().split(' '),
                isTag = false;

            for (let i = words.length - 2, l = 0; i > l; i--) {
                const currentWord = words[i];

                if (isTag) {
                    let bracket = currentWord.indexOf('>');

                    if (bracket) {
                        isTag = false;
                        // TODO: pewnie trzeba tez obsluzyc wystepowanie zamkniecia nawiasu w srodku slowa
                    }
                } else {
                    if (currentWord[0] === '<') {
                        isTag = true;
                    } else {
                        words = this.checkWord(currentWord, words, i);
                    }
                }
            }

            data = words.join(' ');
        }

        return data;
    }
}

export default Orphans;



// WEBPACK FOOTER //
// ./sources/js/components/orphans.js